/** Grymwyrd Korean copy for the Play / VTT feature. */
export const playKo = {
  // CampaignList
  'play.campaigns.heading': '나의 캠페인',
  'play.campaigns.signIn': '로그인',
  'play.campaigns.signInToSee': '참여한 캠페인을 확인하세요.',
  'play.campaigns.fallbackNotice': '예시 캠페인을 표시 중입니다 — 캠페인 목록을 불러올 수 없습니다.',
  'play.campaigns.loading': '사가를 회상 중…',
  'play.campaigns.empty': '아직 참여한 캠페인이 없습니다.',
  'play.campaigns.assignedCharacter': '할당된 캐릭터',
  'play.campaigns.unassigned': '미할당',
  'play.campaigns.noCharactersYet': '캐릭터 없음',
  'play.campaigns.enterCampaign': '캠페인 입장',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': '테이블',
  'play.vtt.launch': 'VTT 시작',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — 캠페인 {campaignId}',
  'play.vtt.veilHeadline': '여기서 테이블과 이야기 사이의 장막은 얇다.',
  'play.vtt.prototypeIntro':
    '실시간 가상 테이블탑은 이후 단계입니다. 인터랙티브 프로토타입이 이 프레임에 임베드됩니다 — ',
  'play.vtt.prototypeOutro': '를 눌러 컨테이너를 준비하세요.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': '코덱스 빠른 검색',
  'play.codex.searchPlaceholder': '몬스터, 주문, 규칙 검색…',
  'play.codex.searchAriaLabel': '백과사전 검색',
  'play.codex.searching': '마법을 감지 중…',
  'play.codex.noResults': '"{q}"에 대한 결과가 없습니다.',
  'play.codex.hint': '테이블을 떠나지 않고 살아있는 백과사전을 검색하려면 최소 두 글자 이상 입력하세요.',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': '캠페인',
  'play.campaign.fallbackDescription':
    '캠페인 정보를 불러올 수 없습니다 — 아래에서 캐릭터를 준비할 수 있습니다.',
  'play.campaign.seoTitle': '캠페인',
  'play.campaign.noneSpecified': '지정된 캠페인이 없습니다.',
  'play.campaign.seoTitleNamed': '{title} — 플레이',
  'play.campaign.seoTitleDefault': '캠페인 — 플레이',
  'play.campaign.backToLobby': '로비로 돌아가기',
  'play.campaign.gm': 'GM {gm}',
  'play.campaign.playersCount': '{count}명의 플레이어',

  // CharacterSheet
  'play.sheet.savedToCodex': '코덱스에 저장되었습니다.',
  'play.sheet.savedLocally': '로컬 저장됨 (서버 사용 불가).',
  'play.sheet.saveError': '캐릭터를 저장할 수 없습니다 — 저장소를 사용할 수 없습니다.',
  'play.sheet.loading': '캐릭터 시트를 펼치는 중…',
  'play.sheet.heading': '캐릭터 시트',
  'play.sheet.avatarAlt': '{name}의 아바타',
  'play.sheet.unclaimedHero': '주인 없는 영웅',
  'play.sheet.abilityCheck': '{ability} 체크 ({formula}):',
  'play.sheet.name': '이름',
  'play.sheet.namePlaceholder': '이름 없는 방랑자',
  'play.sheet.level': '레벨',
  'play.sheet.speciesLabel': '혈통 / 종족',
  'play.sheet.loadingOption': '로딩 중…',
  'play.sheet.selectSpecies': '종족 선택',
  'play.sheet.classLabel': '클래스',
  'play.sheet.selectClass': '클래스 선택',
  'play.sheet.abilityScores': '능력 점수',
  'play.sheet.abilityScoresHint': '(수정치를 클릭하여 주사위 굴리기)',
  'play.sheet.abilityScoreAria': '{ability} 점수',
  'play.sheet.rollCheckAria': '{ability} 체크 주사위 굴리기',
  'play.sheet.hp': 'HP',
  'play.sheet.maxHp': '최대 HP',
  'play.sheet.ac': 'AC',
  'play.sheet.backstory': '배경 이야기',
  'play.sheet.backstoryPlaceholder': '어떤 어둠이 이 영혼을 테이블로 이끌어 왔는가?',
  'play.sheet.canonCandidate': '정사 후보',
  'play.sheet.canonCandidateHint': '이 캐릭터를 살아있는 Grymwyrd 정사의 일부로 고려 대상에 등록하세요.',
  'play.sheet.saving': '저장 중…',
  'play.sheet.saveCharacter': '캐릭터 저장',

  // CreateGameModal
  'play.create.errorNoName': '테이블에 이름을 지어주세요.',
  'play.create.errorNoSystem': '게임 시스템을 선택하세요.',
  'play.create.you': '당신',
  'play.create.errorCreate': '의식이 실패했습니다 — 테이블을 생성할 수 없습니다. 잠시 후 다시 시도하세요.',
  'play.create.modalTitle': '테이블 소집',
  'play.create.successCopy': '테이블이 준비되었습니다. 이 초대 링크를 플레이어들과 공유하세요.',
  'play.create.copyInviteAria': '초대 링크 복사',
  'play.create.copied': '복사됨',
  'play.create.copy': '복사',
  'play.create.done': '완료',
  'play.create.tableName': '테이블 이름',
  'play.create.tableNamePlaceholder': '예: 애도의 금고고',
  'play.create.quickStart': '빠른 시작',
  'play.create.quickStartAria': '빠른 시작 프리셋',
  'play.create.customPreset': '커스텀',
  'play.create.customPresetDesc': '처음부터 시작',
  'play.create.gameSystem': '게임 시스템',
  'play.create.loadingSystems': '시스템 로딩 중…',
  'play.create.systemFromPreset': '{system} (프리셋에서)',
  'play.create.systemDefault': 'Grymwyrd Cataclysm (기본값)',
  'play.create.tags': '태그',
  'play.create.tagsUpTo': '(최대 {count}개)',
  'play.create.removeTagAria': '태그 {tag} 제거',
  'play.create.tagLimitReached': '태그 제한에 도달함',
  'play.create.tagPlaceholder': '공포, 원샷…',
  'play.create.maxPlayers': '최대 플레이어:',
  'play.create.cancel': '취소',
  'play.create.convening': '소집 중…',
  'play.create.createTable': '테이블 생성',

  // JoinPage
  'play.join.finding': '테이블을 찾는 중…',
  'play.join.expiredHeading': '이 초대가 만료되었습니다',
  'play.join.expiredBody': '코드는 보안을 위해 시간 제한이 있습니다. 호스트에게 새로운 코드를 요청하세요.',
  'play.join.browseLiveTables': '실행 중인 테이블 보기',
  'play.join.errorHeading': '테이블에 도달할 수 없습니다',
  'play.join.errorBody': '초대를 조회하는 중 문제가 발생했습니다. 연결을 확인하고 다시 시도하세요.',
  'play.join.tryAgain': '다시 시도',
  'play.join.defaultTableTitle': 'Grymwyrd 테이블',
  'play.join.invited': '테이블에 앉도록 초대받았습니다.',
  'play.join.signInToSeat': '로그인하여 자리에 앉으세요',
  'play.join.createAccount': '처음이신가요? 무료 계정 만들기',
  'play.join.opensAfterSignIn': '로그인 후 테이블이 열립니다.',

  // PlayLobbyPage
  'play.lobby.seoTitle': '플레이 — 가상 테이블탑',
  'play.lobby.seoDescription':
    '테이블을 찾고, 실시간 세션에 참여하며, Grymwyrd 가상 테이블탑에서 전설을 써내세요.',
  'play.lobby.eyebrow': '가상 테이블탑',
  'play.lobby.title': '플레이',
  'play.lobby.subtitle':
    '당신의 무리를 모으세요. 주사위를 굴리세요. 모든 선택이 Grymwyrd의 살아있는 정사에 울려 퍼지는 테이블에 앉으세요.',
  'play.lobby.createGame': '게임 생성',
  'play.lobby.playNow': '지금 플레이 — 계정 불필요',
  'play.lobby.signInToHost': '로그인하여 당신의 테이블을 진행하세요',

  // SessionListLive
  'play.live.heading': '지금 실행 중',
  'play.live.empty': '지금 실행 중인 테이블이 없습니다. 장막이 고요합니다 — 당신의 것을 시작하세요.',
  'play.live.badge': '실행 중',
  'play.live.unknownSystem': '알 수 없는 시스템',
  'play.live.gmSuffix': ' · GM {gm}',
  'play.live.players': '명의 플레이어',

  // TableList — empty board
  'play.tables.emptyHeading': '아직 열린 테이블이 없습니다',
  'play.tables.emptyBody':
    '보드는 지금 조용합니다. 처음으로 자리를 잡아보세요 — 계정 없이 바로 게스트 테이블을 사용해보세요.',
  'play.tables.tryGuestTable': '게스트 테이블 사용해보기',
  'play.tables.orUse': '또는 위의',
  'play.tables.createGame': '게임 생성',
  'play.tables.aboveToHost': '를 사용하여 당신의 테이블을 진행하세요.',

  // TableList — waitlist
  'play.waitlist.joinError': '대기 목록에 참여할 수 없습니다 — 다시 시도하세요.',
  'play.waitlist.leaveError': '대기 목록을 떠날 수 없습니다 — 다시 시도하세요.',
  'play.waitlist.join': '대기 목록에 참여',
  'play.waitlist.leaving': '떠나는 중…',
  'play.waitlist.leave': '대기 목록 떠나기',
  'play.waitlist.joining': '참여 중…',

  // TableList — board
  'play.tables.heading': '열린 테이블',
  'play.tables.openSeatOnly': '열린 자리만',
  'play.tables.systemFilterPlaceholder': '시스템…',
  'play.tables.systemFilterAria': '시스템으로 필터링',
  'play.tables.tagsFilterPlaceholder': '태그 (쉼표로 구분)…',
  'play.tables.tagsFilterAria': '태그로 필터링',
  'play.tables.fetchError': '라이브 보드에 도달할 수 없습니다 — 로비를 일시적으로 사용할 수 없습니다.',
  'play.tables.loading': '테이블을 모으는 중…',
  'play.tables.untitledTable': '제목 없는 테이블',
  'play.tables.full': '가득참',
  'play.tables.seatedCount': '{count}명 참석',
  'play.tables.viewTable': '테이블 보기',

  // ── Live chat (P-E) — per-recipient translation (Option A) ────────────────
  'chat.heading': '테이블 채팅',
  'chat.empty': '아직 메시지가 없습니다. 테이블에 뭔가 말해보세요.',
  'chat.inputPlaceholder': '테이블에 메시지…',
  'chat.inputAria': '채팅 메시지',
  'chat.send': '전송',
  'chat.translatedFrom': '{lang}에서 번역됨',
  'chat.original': '원문',
  'chat.showOriginal': '원문 표시',
  'chat.showTranslation': '번역 표시',
  'chat.showOriginalsAll': '원문 모두 표시',
  'chat.showTranslationsAll': '번역 모두 표시',
}
